import React from 'react'
import { BlockIcon } from 'components/icons/block-icon'
import * as styles from '../Helix.css'

interface StockOptionProps {
	label: string
	isSelected: boolean
	onClick: () => void
	onKeyDown: (e: React.KeyboardEvent) => void
	icon?: any
	type?: string
	style?: React.CSSProperties
}

export const StockOption: React.FC<StockOptionProps> = React.memo(
	({ label, isSelected, onClick, onKeyDown, icon, type, style }) => (
		<div
			className={styles.resultItem({ selected: isSelected })}
			onClick={onClick}
			onKeyDown={onKeyDown}
			tabIndex={isSelected ? 0 : -1}
			role="option"
			aria-selected={isSelected}
			style={style}>
			{icon && (
				<div className={styles.resultIcon}>
					<BlockIcon icon={icon} size="medium" color="neutral.300" />
				</div>
			)}
			<div className={styles.resultContent}>
				<div className={styles.resultInfo}>
					<div className={styles.resultLabel}>{label}</div>
					{type && <div className={styles.resultType}>{type}</div>}
				</div>
			</div>
		</div>
	)
)

StockOption.displayName = 'StockOption'
